<form-popup [(visible)]="visible" (visibleChange)="onVisibleChange($event)"
            (save)="onPopupSaveClick()"
            (open)="onOpen()"
            titleText="Edit Supplier"
            [isSaveDisabled]="isReadOnly">
    <supplier-form [data]="formData" [isReadOnly]="isReadOnly"></supplier-form>
</form-popup>
